import { z } from 'zod';
import { companyInfoSchema } from '../../../../schemas/companyInfoSchema';

export const wizardCompanySchema = companyInfoSchema.extend({
  clientName: z.string().min(1, 'Company Name is required').max(100),
  company_registration: z.string().min(1, 'Primary Business Registration is required').max(50),
  company_website: z
    .string()
    .min(1, 'Company Website is required')
    .max(255)
    .regex(/^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/, 'Invalid website format'),
});

export type WizardFormData = z.infer<typeof wizardCompanySchema>;

export const initialCompanyFormData: WizardFormData = {
  clientName: '',
  company_legal_name: '',
  company_registration: '',
  secondary_company_registration: '',
  company_address: '',
  company_website: '',
  company_phone: '',
  timezone: 'UTC',
  company_contact_name: '',
  company_contact_email: '',
  company_contact_role: '',
  contact_facsimile: '',
  liability_insurer: '',
  liability_insurance_expiry: '',
  liability_insurance_per_claim: '',
  liability_insurance_aggregate: '',
  indemnity_insurer: '',
  indemnity_insurer_expiry: '',
  indemnity_insurer_per_claim: '',
  indemnity_insurer_aggregate: '',
  workers_compensation_insurer_1: '',
  workers_compensation_expiry_1: '',
  workers_compensation_insurer_2: '',
  workers_compensation_expiry_2: '',
  workers_compensation_insurer_3: '',
  workers_compensation_expiry_3: '',
  workers_compensation_insurer_4: '',
  workers_compensation_expiry_4: '',
};
